import { getConsent } from '../components/shared/CookieConsentBanner';

const PIXEL_ID = '2254358008743111';
let loaded = false;

/**
 * Meta (Facebook) Pixel — loaded ONLY after the user has consented to
 * analytics cookies (see CookieConsentBanner). Matches the site's own
 * cookie banner promise: "With your consent, we also use analytics
 * cookies to improve the product." Loading it unconditionally on every
 * page view would fire tracking before consent, contradicting that.
 */
const injectPixelScript = () => {
  /* eslint-disable */
  !function(f,b,e,v,n,t,s)
  {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
  n.callMethod.apply(n,arguments):n.queue.push(arguments)};
  if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
  n.queue=[];t=b.createElement(e);t.async=!0;
  t.src=v;s=b.getElementsByTagName(e)[0];
  s.parentNode.insertBefore(t,s)}(window, document,'script',
  'https://connect.facebook.net/en_US/fbevents.js');
  window.fbq('init', PIXEL_ID);
  /* eslint-enable */
};

export const trackPixelPageView = () => {
  if (window.fbq) window.fbq('track', 'PageView');
};

export const loadMetaPixelIfConsented = () => {
  if (loaded || typeof window === 'undefined') return;
  const consent = getConsent();
  if (consent?.analytics) {
    injectPixelScript();
    trackPixelPageView();
    loaded = true;
  }
};

export const initMetaPixelConsentListener = () => {
  loadMetaPixelIfConsented();
  window.addEventListener('cookie-consent-changed', (e) => {
    if (e.detail?.analytics) loadMetaPixelIfConsented();
  });
};
